"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var extractCamelCase = function extractCamelCase(s) {
  return s.split(/(?=[A-Z])/).map(function (p) {
    return p.charAt(0).toUpperCase() + p.slice(1);
  });
};
exports.extractCamelCase = extractCamelCase;